import {useState} from "react";
import {notification} from "antd";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {AppCheckboxGroup} from "shared/UI/UIKit/Checkbox";
import {AppButton} from "shared/UI/UIKit/Button";
import type {Question} from "../../../../../config/types";

type MultipleQuestionProps = {
  question: Question;
}

export const MultipleQuestion = (props: MultipleQuestionProps) => {
  const [value, setValue] = useState<string[]>([]);
  const [error, setError] = useState(false);
  const [dirty, setDirty] = useState(false);

  const options = props.question.variants.map(item => {
    return {
      label: item.text,
      value: item.id
    };
  });

  const onChange = (e: string[]) => {
    setValue(e);
  };

  const isValid = () => {
    if (value.length !== props.question.answer.length) {
      return false;
    }

    return props.question.answer.reduce((acc: boolean, item: string) => {
      acc = value.includes(item);
      return acc;
    }, false);
  };

  const checkAnswer = () => {
    setDirty(true);
    if (isValid()) {
      setError(false);
      notification.success({
        message: "Вы ответили верно",
        duration: 2,
      });
    } else {
      setError(true);
      notification.error({
        message: "Вы ответили неверно",
        duration: 2,
      });
    }
  };

  const getType = () => {
    if (dirty && error) {
      return "danger";
    }

    if (dirty && !error) {
      return "success";
    }
  };

  return (
    <AppFlex alignItems="flex-start" unit="30">
      <AppText type={getType()} size={24} weight={700}>{props.question.text}</AppText>
      <AppCheckboxGroup value={value} direction="vertical"
                        options={options} onChange={e => onChange(e as string[])}/>
      <AppButton onClick={checkAnswer} disabled={!value.length}>
        Проверить
      </AppButton>
    </AppFlex>
  );
};